import { View } from "@amzn/stencil-react-components/layout";
import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import React, { FC, useEffect, useRef } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

interface CampaignSubmissionBannersProps {
  hasSubmitSucceeded: boolean;
  submitError: Error | null;
  saveAttemptCount: number;
}

export const CampaignSubmissionBanners: FC<CampaignSubmissionBannersProps> = ({
  hasSubmitSucceeded,
  submitError,
  saveAttemptCount,
}) => {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (saveAttemptCount === 0) {
      return;
    }
    bannerRef.current?.scrollIntoView?.({ behavior: "smooth", block: "center" });
    bannerRef.current?.focus();
  }, [saveAttemptCount]);

  if (!hasSubmitSucceeded && !submitError) {
    return null;
  }

  return (
    <View ref={bannerRef} tabIndex={-1} dataTestId="campaign-submission-banner">
      {submitError ? (
        <MessageBanner
          key={saveAttemptCount}
          type={MessageBannerType.Error}
          isDismissible={false}
          aria-live="assertive"
        >
          {getString("campaigns.saveError")}
        </MessageBanner>
      ) : (
        <MessageBanner
          key={saveAttemptCount}
          type={MessageBannerType.Success}
          isDismissible
          aria-live="polite"
        >
          {getString("campaigns.responsesSaved")}
        </MessageBanner>
      )}
    </View>
  );
};
